import { useStore } from 'vuex'
import _stafetCommonStepsProps from '../../foundation/js/configurations/_stafetCommonStepsProps'
import FormInputTextField from '../FormInputTextField/FormInputTextField.vue'
import FormCheckbox from '../FormCheckbox/FormCheckbox.vue'
import StafetActions from '../StafetActions/StafetActions.vue'
import StafetPayment from '../StafetPayment/StafetPayment.vue'
import { ref, computed, onBeforeMount } from 'vue'
import fieldsConfig from './config/fieldsConfig'
import getItemFromStorage from 'foundation/js/sessionStorageWrapper/getItemFromStorage'
import sessionStorageIdentifierEnum from 'foundation/js/sessionStorageWrapper/sessionStorageIdentifierEnum'
import fieldValidator from 'foundation/js/stafet/fieldValidator'
import nameValidator from 'foundation/js/inputValidators/nameValidator'
import emailValidator from 'foundation/js/inputValidators/emailValidator'
import getFieldValue from 'foundation/js/stafet/getFieldValue'

export default {
    name: 'StafetDonationTaendLysStepThree',
    components: {
        FormInputTextField,
        FormCheckbox,
        StafetActions,
        StafetPayment
    },
    props: _stafetCommonStepsProps,
    setup(props) {
        const store = useStore()
        const gtmActive = !!window?.dataLayer?.find(
            (element) => element['gtm.start']
        ) // check if gtm is active 

        const firstName = ref(props.userData?.firstName ?? '')
        const lastName = ref(props.userData?.lastName ?? '')
        const email = ref(props.userData?.email ?? '')
        const isAnonymous = ref(props.userData?.isAnonymous ?? false)

        const basket = computed(() => {
            return store.state.donation.basket
        })

        const basketTotalPrice = computed(() => {
            return store.state.donation.basketTotalPrice
        })

        onBeforeMount(() => {
            const storedFields = getItemFromStorage(
                sessionStorageIdentifierEnum.STAFET_DONATION
            )

            if (storedFields) {
                updateLocalRefs([
                    {
                        name: 'firstName',
                        value:
                            getFieldValue(storedFields, 'firstName') ??
                            firstName.value
                    },
                    {
                        name: 'lastName',
                        value:
                            getFieldValue(storedFields, 'lastName') ??
                            lastName.value
                    },
                    {
                        name: 'email',
                        value:
                            getFieldValue(storedFields, 'email') ?? email.value
                    },
                    {
                        name: 'isAnonymous',
                        value:
                            getFieldValue(storedFields, 'isAnonymous') ??
                            isAnonymous.value
                    }
                ])
            }

            if (!gtmActive) return
            const orderId = new URLSearchParams(document.location.search).get(
                'orderId'
            )
            if (orderId)
                store.dispatch('main/getTrackingData', { orderId })
        })

        const updateLocalRefs = (fields) => {
            fields.forEach((field) => {
                if (field.value === undefined || field.value === null) return
                fieldsConfig.find((item) => item.name === field.name).value =
                    field.value
                switch (field.name) {
                    case 'firstName':
                        firstName.value = field.value
                        return
                    case 'lastName':
                        lastName.value = field.value
                        return
                    case 'email':
                        email.value = field.value
                        return
                    case 'isAnonymous':
                        isAnonymous.value = field.value
                        return
                    default:
                        return
                }
            })
        }

        const validateField = (fieldName, value) => {
            fieldsConfig.find((item) => item.name === fieldName).value = value
            const field = fieldsConfig.find((field) => field.name === fieldName)
            if (field) {
                field.value = value
                fieldValidator(field)
            }
        }

        const showFirstNameErrorMessage = computed(() => {
            return !nameValidator(firstName.value) && props.displayInputError
        })

        const showLastNameErrorMessage = computed(() => {
            return !nameValidator(lastName.value) && props.displayInputError
        })

        const showEmailErrorMessage = computed(() => {
            return !emailValidator(email.value) && props.displayInputError
        })

        const stepModel = computed(() => {
            return fieldsConfig
        })

        return {
            firstName,
            lastName,
            email,
            isAnonymous,
            basket,
            basketTotalPrice,
            stepModel,
            validateField,
            showFirstNameErrorMessage,
            showLastNameErrorMessage,
            showEmailErrorMessage
        }
    }
}
